/* global velloraPreloaderSettings */
import deviceMenu from '@js/common/deviceMenu.js';
import { appendSVGBtn, headeraddClass } from '@js/common/customFunctions.js';

import { initAOS } from '@js/common/aos.js';

deviceMenu();
initAOS();
const preloaderSettings = typeof velloraPreloaderSettings === 'undefined' ? {} : velloraPreloaderSettings;
const preloaderCookieName = preloaderSettings.cookieName || 'vellora_preloader_seen';
const preloaderCookiePath = preloaderSettings.cookiePath || '/';
const preloaderCookieMaxAge = preloaderSettings.cookieMaxAge || 31536000;

/* Script on ready
------------------------------------------------------------------------------*/
document.addEventListener('DOMContentLoaded', () => {
    headeraddClass();
    initResponsiveTables();
    /* Process buttons */
    document.querySelectorAll('.btn').forEach(function(element) {
        const iconWrapper = element.querySelector('i');
        if (!iconWrapper) {
            return;
        }

        // Append exactly two arrows
        appendSVGBtn(iconWrapper, '#icon-right-arrow', 14, 24);
        appendSVGBtn(iconWrapper, '#icon-right-arrow', 14, 24);
    });
    document.querySelectorAll('.btn-link').forEach(function(element) {
        const iconWrapper = element.querySelector('i');
        if (!iconWrapper) {
            return;
        }
        appendSVGBtn(iconWrapper, '#icon-btn-arrow', 24, 24);
    });
    /* Process buttons End */

    // Social Icon
    document.querySelectorAll('a').forEach(function(element) {
        if (element.classList.contains('heateor_sss_button_linkedin')) {
            appendSVGBtn(element, '#icon-linkedin', '24', '24');
        } else if (element.classList.contains('heateor_sss_button_x')) {
            appendSVGBtn(element, '#icon-x', '24', '24');
        } else if (element.classList.contains('heateor_sss_facebook')) {
            appendSVGBtn(element, '#icon-facebook', '24', '24');
        } else if (element.classList.contains('heateor_sss_more')) {
            appendSVGBtn(element, '#icon-more', '24', '24');
        } else if (element.classList.contains('heateor_sss_whatsapp')) {
            appendSVGBtn(element, '#icon-whatsapp', '24', '24');
        }
    });

    document.querySelectorAll('.post-detail-body .heateor_sss_sharing_ul > a').forEach(function(el) {
        el.removeAttribute('style');
    });

    /* Preloader
    ------------------------------------------------------------------------------*/
    const loader = document.getElementById('preloader');

    if (!loader) {
        return;
    }

    if (hasCookie(preloaderCookieName)) {
        loader.remove();
        return;
    }

    initLoader(loader);
});

/* Use jQuery code Start
------------------------------------------------------------------------------*/

(function($) {
    // Write code here
})(jQuery);

/* ------------------------------------------------------------------------------
Use jQuery code End */

function initLoader(loader) {
    const circle = loader.querySelector('.progress-bar');
    const percentText = loader.querySelector('#percent');

    if (!circle || !percentText) {
        return;
    }

    loader.style.display = 'flex';
    setCookie(preloaderCookieName, '1', preloaderCookieMaxAge, preloaderCookiePath);

    const circumference = 628;
    let progress = 0;

    function updateProgress(value) {
        percentText.textContent = value;

        const offset = circumference - (value / 100) * circumference;

        circle.style.strokeDashoffset = offset;
    }

    function finishLoader() {
        clearInterval(fakeLoad);

        const finish = setInterval(() => {
            progress++;

            updateProgress(progress);

            if (progress >= 100) {
                clearInterval(finish);

                setTimeout(() => {
                    loader.style.opacity = '0';

                    setTimeout(() => {
                        loader.remove();
                    }, 600);
                }, 300);
            }
        }, 15);
    }

    const fakeLoad = setInterval(() => {
        if (progress < 95) {
            progress += Math.floor(Math.random() * 4) + 1;

            if (progress > 95) {
                progress = 95;
            }

            updateProgress(progress);
        }
    }, 100);

    // If page already loaded
    if (document.readyState === 'complete') {
        finishLoader();
    } else {
        window.addEventListener('load', finishLoader);
    }
}

function hasCookie(name) {
    return document.cookie.split('; ').some(function(cookie) {
        return cookie.startsWith(`${encodeURIComponent(name)}=`);
    });
}

function setCookie(name, value, maxAge, path) {
    const cookieParts = [
        `${encodeURIComponent(name)}=${encodeURIComponent(value)}`,
        `max-age=${maxAge}`,
        `path=${path}`,
        'samesite=lax',
    ];

    if (window.location.protocol === 'https:') {
        cookieParts.push('secure');
    }

    document.cookie = cookieParts.join('; ');
}

document.addEventListener('DOMContentLoaded', function() {
    if (typeof jQuery === 'undefined') {
        return;
    }

    jQuery(document).on('forminator:form:submit:success', '.forminator-custom-form',
        function() {
            if (typeof window.gtag === 'function') {
                window.gtag('event', 'generate_lead', {
                    form_name: 'Contact Enquiry Form',
                });
            }
        },
    );
});


/**
 * Initializes responsive behavior for HTML tables:
 * - Wraps all <table> elements (excluding those with .no-wrap) in a .wc-table div.
 * - Further wraps them in a .table-wrapper div for layout control.
 * - On mobile viewports (<768px), transforms tables into column-based blocks for better readability.
 * - Reverts to normal tables on larger viewports.
 * - Handles window resizing with debounce to toggle views dynamically.
 */

function initResponsiveTables() {
    // Wrap tables not marked with .no-wrap in a .wc-table div

    function wrapWCtables() {
        document.querySelectorAll('table:not(.no-wrap)').forEach(table => {
            if (table.hasAttribute('style')) {
                return;
            }

            if (table.querySelector(':scope tr[style], :scope td[style], :scope th[style]')) {
                return;
            }

            const wrapper = document.createElement('div');
            wrapper.className = 'wc-table';
            table.parentNode.insertBefore(wrapper, table);
            wrapper.appendChild(table);
        });
    }

    // Wrap .wc-table tables in a .table-wrapper div if not already wrapped
    function wrapTables() {
        document.querySelectorAll('.wc-table table').forEach(function(table) {
            if (!table.parentElement.classList.contains('table-wrapper')) {
                const wrapper = document.createElement('div');
                wrapper.className = 'table-wrapper';
                table.parentNode.insertBefore(wrapper, table);
                wrapper.appendChild(table);
            }
        });
    }

    // Build mobile view for a given wrapper
    function buildMobileTableView(wrapper) {
        const table = wrapper.querySelector('table');
        if (!table || wrapper.querySelector('.mobile-table-view')) {
            return;
        }

        const rows = table.querySelectorAll('tbody tr');
        if (rows.length === 0) {
            return;
        }

        const numColumns = rows[0].children.length;
        const columns = Array.from({
            length: numColumns,
        }, () => []);

        rows.forEach((row, rowIndex) => {
            Array.from(row.children).forEach((cell, colIndex) => {
                columns[colIndex].push({
                    isHeader: rowIndex === 0,
                    content: cell.innerHTML.trim(),
                });
            });
        });

        const mobileView = document.createElement('div');
        mobileView.className = 'mobile-table-view';

        columns.forEach((colData) => {
            const colBlock = document.createElement('div');
            colBlock.className = 'column-block';

            colData.forEach((cell) => {
                const div = document.createElement('div');
                div.className = cell.isHeader ? 'column-header' : 'column-cell';
                div.innerHTML = cell.content;
                colBlock.appendChild(div);
            });

            mobileView.appendChild(colBlock);
        });

        table.insertAdjacentElement('afterend', mobileView);
    }

    // Responsive logic: add/remove mobile view based on screen size
    function handleResponsiveTables() {
        wrapTables();

        document.querySelectorAll('.table-wrapper').forEach(wrapper => {
            const isMobile = window.innerWidth < 768;
            const hasMobileView = wrapper.querySelector('.mobile-table-view');

            if (isMobile && !hasMobileView) {
                buildMobileTableView(wrapper);
            }

            if (!isMobile && hasMobileView) {
                wrapper.querySelector('.mobile-table-view').remove();
            }
        });
    }

    // Initialize all responsive table logic
    wrapWCtables();
    handleResponsiveTables();

    // Resize listener with debounce
    window.addEventListener('resize', () => {
        clearTimeout(window._tableResizeTimeout);
        window._tableResizeTimeout = setTimeout(handleResponsiveTables, 200);
    });
};